import { render, staticRenderFns } from "./individualCallSplit.vue?vue&type=template&id=0977f148&scoped=true"
import script from "./individualCallSplit.vue?vue&type=script&lang=js"
export * from "./individualCallSplit.vue?vue&type=script&lang=js"
import style0 from "./individualCallSplit.vue?vue&type=style&index=0&id=0977f148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0977f148",
  null
  
)

export default component.exports